import React from 'react';
import cx from 'classnames';

import styles from './ArticlesItemCommentInfo.module.scss';

interface IArticlesItemCommentInfoProps {
  className?: string;
  commentsName: string;
  commentsCount: number;
}

const ArticlesItemCommentInfo: React.FC<IArticlesItemCommentInfoProps> = ({
  commentsName,
  commentsCount,
  className
}) => {
  return (
    <span className={cx(styles.container, className)}>
      <span className={styles.name}>{commentsName}</span>
      <span className={styles.count}>{`(${commentsCount ?? 0})`}</span>
    </span>
  );
};

export default ArticlesItemCommentInfo;
